import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-fields"
// Generic controller for adding/removing nested form fields
export default class extends Controller {
  static targets = ["template", "container", "field"]

  declare templateTarget: HTMLTemplateElement
  declare containerTarget: HTMLElement
  declare fieldTargets: HTMLElement[]

  add(event: Event): void {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, String(new Date().getTime()))
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event: Event): void {
    event.preventDefault()
    const field = (event.target as HTMLElement).closest("[data-nested-fields-target='field']")
    if (field) {
      field.remove()
    }
  }
}
